// --- Keys used in localStorage ---
const TOKEN_KEY = 'jsp_staffToken';
const USER_KEY = 'jsp_staff';
const LOGIN_TIME_KEY = '__staffLoginTime';
const LAST_ACTIVITY_KEY = '__staffLastActivity';

const EXPIRY_MS = 24 * 60 * 60 * 1000;
const INACTIVITY_MS = 30 * 60 * 1000;


export const loginUser = (token, user, permissions) => {
    const now = Date.now();
    localStorage.setItem(TOKEN_KEY, token);
    localStorage.setItem(USER_KEY, user);
    localStorage.setItem(LOGIN_TIME_KEY, now);
    localStorage.setItem(LAST_ACTIVITY_KEY, now);
    localStorage.setItem('jsp_staff_permissions', permissions);

    // window.location = '/applicationportal/dashboard';
};


export const logoutUser = () => {
    console.log('staff log out');
    localStorage.removeItem(TOKEN_KEY);
    localStorage.removeItem(USER_KEY);
    localStorage.removeItem(LOGIN_TIME_KEY);
    localStorage.removeItem(LAST_ACTIVITY_KEY);
    window.location = '/securedpanel/auth/login';

    // let's add a return to return to current page before logout
};


export const isAuthenticated = () => {
    const token = localStorage.getItem(TOKEN_KEY);
    const user = localStorage.getItem(USER_KEY);
    const loginTime = Number(localStorage.getItem(LOGIN_TIME_KEY));
    const lastActivity = Number(localStorage.getItem(LAST_ACTIVITY_KEY));
    console.log('staff authenthicating');

    if (!token || !user || !loginTime || !lastActivity) return false;

    const now = Date.now();

    if (now - lastActivity > INACTIVITY_MS) {
        logoutUser();
        return false;
    }
    // if (now - loginTime > EXPIRY_MS) {
    //     logoutUser();
    //     return false;
    // }

    localStorage.setItem(LAST_ACTIVITY_KEY, now);
    return true;
};


export const getAuthToken = () => {
    return isAuthenticated() ? JSON.parse(localStorage.getItem(TOKEN_KEY)) : null;
};


export const getStaff = () => {
    const user = localStorage.getItem(USER_KEY);
    try {
        return user ? JSON.parse(user) : null;
    } catch {
        return user;
    }
};
